// src/pages/TermsConditionsPage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TermsConditionsPage = () => {
  const navigate = useNavigate();

  // Ensure page loads at the top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const SectionTitle = ({ children }) => (
    <h2 className="text-xl font-black text-[#0F2F63] mt-8 mb-4 border-b border-gray-100 pb-2">
      {children}
    </h2>
  );

  const BulletPoint = ({ children }) => (
    <li className="flex items-start mb-2.5">
      <span className="text-[#FF7A59] mr-3 mt-1.5"><i className="fas fa-circle text-[6px]"></i></span>
      <span className="text-gray-600 font-medium leading-relaxed flex-1">{children}</span>
    </li>
  );

  return (
    <div className="py-6 px-4 md:px-8 max-w-4xl mx-auto w-full min-h-[70vh] animate-fade-in">
      
      {/* Header */}
      <div className="flex items-center gap-4 mb-6 border-b border-gray-100 pb-5">
        <button 
          onClick={() => navigate(-1)} 
          className="w-10 h-10 rounded-full bg-white shadow-sm border border-gray-200 hover:bg-gray-50 flex items-center justify-center text-gray-600 transition-colors"
        >
          <i className="fas fa-arrow-left"></i>
        </button>
        <h1 className="text-2xl md:text-3xl font-black text-[#0F2F63] flex items-center gap-3">
          <i className="fas fa-file-contract text-[#FF7A59]"></i> Terms & Conditions
        </h1>
      </div>

      {/* Content Container */}
      <div className="bg-white p-6 md:p-10 rounded-3xl shadow-sm border border-gray-100">
        
        <SectionTitle>1. Introduction</SectionTitle>
        <p className="text-gray-600 font-medium leading-relaxed mb-4">
          Welcome to SV MART. These Terms and Conditions outline the rules and regulations for the use of our website and mobile application. By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.
        </p>

        <SectionTitle>2. User Accounts</SectionTitle>
        <ul className="mb-4">
          <BulletPoint>You must be at least 18 years old to create an account and use this Service.</BulletPoint>
          <BulletPoint>You are responsible for safeguarding your password and OTPs. SV MART will not be liable for any loss or damage arising from your failure to protect your account.</BulletPoint>
          <BulletPoint>You must provide accurate, complete, and current information at all times. Failure to do so constitutes a breach of the Terms.</BulletPoint>
        </ul>

        <SectionTitle>3. Products and Pricing</SectionTitle>
        <p className="text-gray-600 font-medium leading-relaxed mb-4">
          We strive to provide accurate product descriptions and pricing. However, errors may occur. 
        </p>
        <ul className="mb-4">
          <BulletPoint>All prices are listed in Indian Rupees (INR) and are inclusive of applicable taxes unless stated otherwise.</BulletPoint>
          <BulletPoint>We reserve the right to modify prices, products, and services without prior notice.</BulletPoint>
          <BulletPoint>In the event a product is listed at an incorrect price, we have the right to refuse or cancel orders placed for that product.</BulletPoint>
        </ul>

        <SectionTitle>4. Orders and Payments</SectionTitle>
        <ul className="mb-4">
          <BulletPoint>By placing an order, you are making an offer to purchase products subject to these Terms.</BulletPoint>
          <BulletPoint>Online payments are securely processed through Razorpay. We do not store your card or bank details.</BulletPoint>
          <BulletPoint>Cash on Delivery (COD) may be subject to additional verification and limits based on your location and order history.</BulletPoint>
        </ul>

        <SectionTitle>5. Delivery and Shipping</SectionTitle>
        <ul className="mb-4">
          <BulletPoint>Delivery timelines (e.g., Quick Delivery vs Standard Delivery) are estimates and may vary due to external factors like weather or traffic conditions.</BulletPoint>
          <BulletPoint>We utilize GPS and location data to optimize your delivery route. Please ensure your delivery address and pin code are accurate.</BulletPoint>
          <BulletPoint>If a delivery fails due to an incorrect address provided by you, re-delivery charges may apply.</BulletPoint>
        </ul>

        <SectionTitle>6. Returns and Refunds</SectionTitle>
        <p className="text-gray-600 font-medium leading-relaxed mb-4">
          Our goal is your complete satisfaction. If you receive a damaged or incorrect product, you may raise an issue directly through the app's Order Details page.
        </p>
        <ul className="mb-4">
          <BulletPoint>Return requests must be initiated within the specified return window for the respective category (e.g., perishables vs non-perishables).</BulletPoint>
          <BulletPoint>Refunds for online payments will be processed back to the original payment method within 5-7 business days.</BulletPoint>
        </ul>

        <SectionTitle>7. Limitation of Liability</SectionTitle>
        <p className="text-gray-600 font-medium leading-relaxed mb-4">
          In no event shall SV MART, nor its directors, employees, or partners, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
        </p>

        <SectionTitle>8. Changes to Terms</SectionTitle>
        <p className="text-gray-600 font-medium leading-relaxed mb-4">
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms.
        </p>

      </div>
    </div>
  );
};

export default TermsConditionsPage;